<template>
  <div class="page-box">
    <Header />
    <!-- Banner 区 -->
    <div class="page-content bg-color-EAF1FA">
      <div class="top-box max-width-1920"
        :style="{ backgroundImage: `url(${require('@/assets/product/robot/LM211/banner.jpg')})` }">
        <div class="content-positioning" data-aos="fade-up" :style="contentStype">
          <div class="title-1" :style="titleStyle">AI 智能零售机器人 LM211</div>
          <div class="title-2">具备货物分拣、货架整理等功能，可迎宾导购、人机互动<br>
替代人工重复作业，节约基础人力成本
            <div class="title-3" @click="openContactUs">
              申请试用
            </div>
          </div>
        </div>

      </div>

      <!-- 核心能力 -->
      <div class="capability-section" data-aos="fade-up">
        <div class="section-title-small">核心技术</div>
        <div class="section-subtitle">三大核心模块 打造智能操作型零售机器人</div>
        <div class="capability-grid">
          <div class="capability-card" v-for="(item, index) in capabilityList" :key="index">
            <img class="capability-icon" :src="item.icon" alt="">
            <div class="capability-name">{{ item.name }}</div>
            <div class="capability-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>

      <div class="capability-section" data-aos="fade-up">
        <div class="section-title-small">核心卖点</div>
        <div class="section-subtitle">双臂智能操作 实现新零售货架与仓储自动化运营</div>
        <div class="capability-grid1">
          <div class="capability-card" v-for="(item, index) in featureList" :key="index">
            <img class="capability-icon" :src="item.icon" alt="">
            <div class="capability-name">{{ item.name }}</div>
            <div class="capability-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>


      <!-- 技术特点 -->
      <div class="feature-section" data-aos="fade-up"
        :style="{ backgroundImage: `url(${require('@/assets/product/robot/LM211/icon8.jpg')})` }">
      </div>


      <div class="flor3" data-aos="fade-up">
        <div class="f2-title">适配应用场景</div>
        <div class="f2-subtitle">聚焦中大型零售领域 适配商超全流程自动化运营场景</div>

        <div class="scene-cards-container">
          <div class="scene-card-item" v-for="(scene, index) in sceneList" :key="index">
            <div class="f3-card">
              <img class="bgimg" :src="scene.icon" />
              <div class="title">{{ scene.name }}</div>
              <div class="subtitle">{{ scene.desc }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部联系方式 -->
      <Footer />
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import metaInfo from "@/common/util/metaInfo"

export default {
  metaInfo: metaInfo.LM211,
  components: {
    Header,
    Footer
  },
  data() {
    return {
      capabilityList: [
        { icon: require("@/assets/product/robot/LM211/icon1.svg"), name: 'VLA-W 多模态模型', desc: '视觉 - 语言 - 动作深度融合，精准理解操作指令，动作执行准确率达 98%。' },
        { icon: require("@/assets/product/robot/LM211/icon2.svg"), name: '双臂灵巧操作模块', desc: '7 个自由度高精度关节，实现分拣、打包、补货等精细化肢体操作。' },
        { icon: require("@/assets/product/robot/LM211/icon3.svg"), name: '智能感知模块', desc: '融合视觉与空间定位，实时避障，保障操作过程中商品与设备无损伤。' },
      ],
      featureList: [
        { icon: require("@/assets/product/robot/LM211/icon4.svg"), name: '货架智能补货', desc: '自动识别缺货空位，精准完成商品摆放、归类，保持陈列整齐规范。' },
        { icon: require("@/assets/product/robot/LM211/icon5.svg"), name: '货物分拣打包', desc: '高效完成商品分拣、装袋、打包，适配商超线下与线上订单处理需求。' },
        { icon: require("@/assets/product/robot/LM211/icon6.svg"), name: '多模态人机交互', desc: '语音 + 屏幕 + 肢体动作联动，迎宾导购同时可响应操作指令。' },
        { icon: require("@/assets/product/robot/LM211/icon7.svg"), name: '场景智能切换', desc: '支持补货、分拣、导购多模式一键切换，适配商超不同时段运营需求。' }
      ],
      sceneList: [
        { icon: require("@/assets/product/robot/LM211/icon9.png"), name: '大型连锁商超', desc: '适配品类多、货架广、补货频繁的特点，通过双臂智能操作完成货架自动补货、商品归位与陈列整理，降低人工依赖，提升卖场管理与运营效率。' },
        { icon: require("@/assets/product/robot/LM211/icon10.png"), name: '购物中心精品店', desc: '针对高端商品陈列要求高的场景，精准完成商品摆放、归位与整理，保持陈列统一美观，减少人工误差，有效提升店铺形象与顾客购物体验。' },
        { icon: require("@/assets/product/robot/LM211/icon11.png"), name: '商超仓储区', desc: '适配高强度分拣、打包、归类作业需求，高效完成线上线下订单分拣与打包，实现仓储与卖场无缝对接，助力商超构建一体化自动化运营体系。' },

      ]
    }
  },
  methods: {
    openContactUs() {
      this.$root.$emit('openContactUs', 'LM211')
    }
  }
}
</script>

<style lang="less" scoped>
.page-box {
  background-color: #fff;
}

/* Banner 区域 */
.top-box {
  width: 100%;
  min-width: 1200px;
  height: 600px;
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: center;
  display: flex;
  justify-content: center;
}

.max-width-1920 {
  max-width: 1920px;
  width: 100%;
  padding-top: 70px;
}

.content-positioning {
  width: 1200px;
  text-align: center;
  padding-top: 100px;
}

.title-1 {
  font-weight: bold;
  font-size: 42px;
  color: #222222;
  line-height: 57px;
  letter-spacing: 1px;
  text-align: justify;
}

.title-2 {
  font-size: 24px;
  color: #222222;
  line-height: 42px;
  text-align: justify;
  margin-top: 33px;
}

.title-3 {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 180px;
  height: 50px;
  background: linear-gradient(270deg, #29ABFE 0%, #016BFF 100%);
  border-radius: 8px;
  font-weight: bold;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 16px;
  text-align: center;
  cursor: pointer;
}


/* 通用区块样式 */
.section-title {
  font-weight: bold;
  font-size: 32px;
  color: #222222;
  line-height: 34px;
  text-align: center;
  margin-bottom: 40px;
}

.section-title-small {
  font-weight: bold;
  font-size: 32px;
  color: #222222;
  line-height: 34px;
  text-align: center;
  margin-bottom: 10px;
}

.section-subtitle {
  font-size: 16px;
  color: #595859;
  line-height: 21px;
  text-align: center;
}

/* 核心能力 */
.capability-section {
  width: 100%;
  padding: 80px 0;
  background: #ffffff;
}

.capability-grid {
  width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-top: 20px;
  ;
}

.capability-grid1 {
  width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-top: 20px;
  ;
}

.capability-card {
  background: linear-gradient(180deg, #FAFCFF 0%, #ECF2FF 100%);
  border-radius: 6px;
  border: 1px solid #ECF2FF;
  padding: 32px;
  text-align: center;
  transition: all 0.3s;
  flex: 1;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
  }
}

.capability-icon {
  width: 40px;
  height: 40px;
  margin-bottom: 16px;
  object-fit: contain;
}

.capability-name {
  font-size: 20px;
  font-weight: 600;
  color: #222222;
  margin-bottom: 8px;
}

.capability-desc {
  font-size: 14px;
  color: #666666;
  line-height: 22px;
}


/* 技术特点 */
.feature-section {
  width: 100%;
  padding: 80px 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 80vh;
  /* 视窗高度的 80% */
}



.flor3 {
  width: 100%;
  background: #F4F5FB;
  display: flex;
  flex-direction: column;
  padding: 80px 0 80px;

  .f2-title {
    font-weight: bold;
    font-size: 32px;
    color: #222222;
    line-height: 34px;
    text-align: center;
    margin-bottom: 35px;
  }

  .f2-subtitle {
    font-size: 16px;
    color: #222222;
    line-height: 30px;
    text-align: center;
    margin-bottom: 40px;
  }

  .scene-cards-container {
    width: 1200px;
    margin: 0 auto;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }

  .scene-card-item {
    border-radius: 6px;
    overflow: hidden;
  }

  .f3-card {
    background: #ffffff;
    border-radius: 6px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .f3-card .bgimg {
    width: 100%;
    height: 240px;
    object-fit: cover;
  }

  .f3-card .title {
    font-weight: bold;
    font-size: 22px;
    color: #222222;
    line-height: 22px;
    text-align: left;
    padding: 20px;
    margin: 0;
  }

  .f3-card .subtitle {
    font-size: 14px;
    color: #222222;
    line-height: 22px;
    text-align: justify;
    padding: 0 20px 20px 20px;
    margin: 0;
    flex: 1;
  }

}
</style>
